import { normaliseFoetalHeart } from "features/pregnancy/utils/normaliseFoetalHeart";

export const buildInitialObsState = (foetuses, existingObservations) => {
  const map = {};
  foetuses.forEach((f) => {
    const obs = existingObservations?.find(
      (o) =>
        o.foetusId === f.id ||
        o.pregnancyFoetus?.foetusIdentifier === f.foetusIdentifier
    );
    map[f.foetusIdentifier] = {
      foetusId: f.id,
      presentation: obs?.presentation ?? "",
      engagement: obs?.engagement ?? "",
      // Older visits stored "yes"/"no"; map to the spec wording so the Select pre-selects (KIN-2072).
      heartHeardWithDoppler: normaliseFoetalHeart(obs?.heartHeardWithDoppler) ?? "",
      activity: obs?.activity ?? "",
      heartRateBpm: obs?.heartRateBpm != null ? String(obs.heartRateBpm) : "",
      estimatedWeightGrams:
        obs?.estimatedWeightGrams != null
          ? String(obs.estimatedWeightGrams)
          : "",
      notes: obs?.notes ?? "",
    };
  });
  return map;
};
